<template>
	<div id="app">
		<verifyAccess></verifyAccess>
	</div>
</template>
<script>
import verifyAccess from '@/components/verifyAccess/ideologicalAccess.vue';
// import verifyAccess from '@/components/verifyAccess/index.vue';
// import verifyAccess from '@/components/topNavigation.vue';
export default {
	name: '',
	components: { verifyAccess },
	mixins: [],
	props: {},
	data() {
		return {};
	},
	computed: {},
	watch: {},
	mounted() {},
	methods: {},
};
</script>
<style lang="less">
@media screen and (max-width: 769px) {
	#app {
		// max-width: 769px;
	}
	.spanATitle {
		color: #363636;
		cursor: pointer;
	}
	.spanATitle:hover {
		color: #015293;
	}
	::v-deep body {
		min-width: 100%;
	}
}
</style>
